export default __webpack_public_path__ + "02e6291.png";